module.exports = __webpack_public_path__ + "static/img/gjzq.930c2633.png";